import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import ReactDOM from "react-dom";

class BookFeesDetails extends Component {
    state = {
        promoCode: null,
        promoCodeMsg: null,
        promoCodeLoading: false,
        isSuccess: false,
        promoTotal: null,
        payment: {
            payment_method: 0,
        },

    };

    componentWillReceiveProps(nextProps, prevState) {
        if (nextProps && nextProps.error) {
            if (nextProps.error.code === 55) {
                this.setState({
                    promoCodeMsg: nextProps.error.desc,
                    isSuccess: false,
                })
            } else if (nextProps.error.code === 20) {
                this.setState({
                    promoCodeMsg: nextProps.currentBookingFeesDetails ? nextProps.currentBookingFeesDetails.promo_msg : null,
                    isSuccess: true,
                })
            }
        }
    }


    handlePromoCodeSubmission = (e) => {
        let promoCodeFieldValue = document.getElementById('promoCode').value;
        let errorMsg = document.getElementById('promo-code-error-msg');
        let successMsg = document.getElementById('promo-code-success-msg');

        if (errorMsg && successMsg) {
            successMsg.value = "";
            errorMsg.value = "";
        }
        this.setState({
            promoCodeMsg: null,
            promoCode: promoCodeFieldValue,
        }, async () => {
            // prevent default behavior
            e.preventDefault();

            if (!this.state.promoCode) {
                this.setState({
                    promoCodeMsg: this.props.translate('code_required'),
                    isSuccess: false,
                })
            } else {
                this.setState({
                    promoCode: promoCodeFieldValue,
                    promoCodeMsg: null
                });
                await this.props.getBookingFees(e, this.props.services, this.state.promoCode);
            }
        });

    };
    setPaymentMethod = (paymentMethodNo) => {
        this.setState({
            payment: {
                payment_method: paymentMethodNo,
            }
        })
    };

    render() {
        const {currentBookingFeesDetails, translate, submittingToServer, handleSubmitReservation} = this.props;
        const selectedServicesList = currentBookingFeesDetails.services && currentBookingFeesDetails.services.length ? currentBookingFeesDetails.services.map((service, index) => {
            return (
                <li className="m-b-5" key={index}>
                    <span className="capitalized main-darker-color bolder">{service.name}</span>
                    <span
                        className="pull-right">{service.price + " " + translate("currency")} </span>
                </li>
            )
        }) : null;
        return (
            <ul className="list-unstyled no-margin" id="book-fees-list">
                <div className="fees-details">
                    {
                        currentBookingFeesDetails.offer ?
                            <li>
                                <span className="capitalized main-darker-color bolder">{translate("offer")}</span>
                                {currentBookingFeesDetails ?
                                    <span
                                        className="pull-right">{currentBookingFeesDetails.offer + " " + translate("currency")}</span>
                                    : null}
                                {/*<span
                                    className="pull-right">{currentBookingFeesDetails.offer.price + " " + (currentBookingFeesDetails.offer.price_type === 0 ? translate("currency") : "% ")}</span>*/}

                            </li>
                            : null
                    }

                    {selectedServicesList ? <div>
                        <hr style={{marginTop: "5px", marginBottom: "5px"}}/>
                        {selectedServicesList}
                        <hr style={{marginTop: "5px", marginBottom: "5px"}}/>
                    </div> : null}
                    <li>
                        <span className="capitalized main-darker-color bolder">{translate("fees")}</span>
                        <span
                            className="pull-right">{currentBookingFeesDetails.subtotal_fees + " " + translate("currency")} </span>
                    </li>
                    {/*      {
                    (this.props.authUser.is_premium === 1 && currentBookingFeesDetails.discount_money != 0) ?
                        <li>
                            <span className="capitalized main-darker-color bolder">{translate("discount")}</span>
                            <span
                                className="pull-right red">{"-" + " " + currentBookingFeesDetails.discount_money + " " + translate("currency")}</span>
                        </li>
                        : null
                }
                <li hidden={!currentBookingFeesDetails.percentage}>
                    <span className="capitalized main-darker-color bolder">{translate("discount")}</span>
                    <span
                        className="pull-right red-notation">{currentBookingFeesDetails.percentage ? currentBookingFeesDetails.percentage : null} %</span>
                </li>*/}

                    <li>
                        <span className="capitalized main-darker-color bolder">{translate("total_fees")}</span>

                        <span
                            className="pull-right">{currentBookingFeesDetails.total_fees + " " + translate("currency")}</span>
                        <span className="icon pull-right">
                            <img src="/images/floos.png" className="money-icon" alt="money"/>
                        </span>
                        {
                            currentBookingFeesDetails && currentBookingFeesDetails.old_total ?
                                <strike
                                    className="pull-right">{currentBookingFeesDetails.old_total + " " + translate("currency")}
                                </strike>
                                : null
                        }

                    </li>
                </div>
                {/******************Promo code area*****************/}
                <div className="promo-code-area">
                    <div className="promo-code-title">
                        <h6>{translate('promo_code')}</h6>
                    </div>
                    <div className="form-group d-flex relative promo-code-form">
                        <input id="promoCode" type="text"
                               className="form-control align-right-rtl promo-code-field"
                               placeholder={this.props.translate("enter_your_promo_code")}/>
                        <div className="relative center promo-code-btn">
                            {!this.props.promoCodeLoading ?
                                <button className="cursor-pointer redeem-btn"
                                        onClick={(e) => this.handlePromoCodeSubmission(e)}>{this.props.translate('redeem')}</button>
                                :
                                <span id="loading" className="absolute">
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading.svg" alt="loading"/>
                                                </span>
                            }
                        </div>

                        <span className="error-msg promo-code-msg"
                              style={this.state.isSuccess ? {color: "#00ad5f"} : {}}>{this.state.promoCodeMsg}</span>
                        {/*{this.props.error && this.props.error.code === 55 ? <span*/}
                        {/*className="error-msg promo-code-msg" id="promo-code-error-msg">{this.props.error.desc}</span> :*/}
                        {/*(*/}
                        {/*this.props.error && this.props.error.code === 20 ?*/}
                        {/*<span*/}
                        {/*className="error-msg promo-code-msg" id="promo-code-success-msg"*/}
                        {/*style={{color: "#00ad5f"}}>{this.props.currentBookingFeesDetails ? this.props.currentBookingFeesDetails.promo_msg : null}</span> : null*/}
                        {/*)*/}
                        {/*}*/}

                    </div>
                </div>
                {/******************Payment Method*****************/}
                <div className="payment-methods-area">
                    <div className="payment-title">
                        <h6>{translate('payment_methods')}</h6>
                    </div>
                    <div className="payment-method">
                        <div className="payment-method-cash cursor-pointer" onClick={() => this.setPaymentMethod(0)}>
                            <h6>{translate('cash')}&nbsp;&nbsp;
                                <i className="main-darker-color fas fa-check-circle"
                                   hidden={this.state.payment.payment_method !== 0}></i>
                            </h6>
                        </div>
                        <hr/>
                        {/* <div className="cursor-pointer" onClick={() => this.setPaymentMethod(1)}>
                            <h6>{translate('cash_back')}&nbsp;&nbsp;
                                <i className="main-darker-color fas fa-check-circle"
                                   hidden={this.state.payment.payment_method !== 1}></i>
                            </h6>
                            <p>{translate('cash_back_desc')}</p>
                        </div>
                        <hr/>*/}
                        <div className="cursor-pointer" onClick={() => this.setPaymentMethod(2)}>
                            <h6>{translate('credit_card_instalment')}&nbsp;&nbsp;
                                <i className="main-darker-color fas fa-check-circle"
                                   hidden={this.state.payment.payment_method !== 2}></i>
                            </h6>
                            <p>{translate('instalment_desc')}</p>
                        </div>
                    </div>
                </div>
                <li className="book-btn-wrapper relative">
                    <div className="form-group relative">
                        <button
                            className="btn btn-book btn-block shadow-4d height-45"
                            onClick={() => handleSubmitReservation(this.state.payment, this.state.promoCode, this.props.services)}>
                            {translate("submit")}
                        </button>
                        <img src="../images/loading-white.svg"
                             alt="loading"
                             hidden={!submittingToServer}/>
                    </div>
                </li>

            </ul>

        )
    }
}

export default withTranslate(BookFeesDetails);

